import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Table from '@material-ui/core/Table';
import PreShopTableHead from '../../components/molecules/PreShopTableHead';
import PreShopTableBody from '../../components/molecules/PreShopTableBody';
import PreShopEdit from './PreShopEdit';
import PreShopDetail from './PreShopDetail';
// import TablePagination from '../../components/molecules/TablePagination';
import ExPagination from '../../components/molecules/ExPagination';
import { getPreShopDetail } from '../../actions/PreShops';
import { sendLogin } from '../../auth/Auth';

const styles = {
  scrollTable: {
    // maxHeight: 375,
    maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      preShops: state.preShops.preShops,
      totalCount: state.preShops.totalCount,
      offset: state.preShops.offset
    }),
    dispatch => ({
      actions: bindActionCreators({ getPreShopDetail }, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openDetailModal', 'updateOpenDetailModal', false),
  withState('openEditModal', 'updateOpenEditModal', false),
  withState('openEditConfirm', 'updateOpenEditConfirm', false),
  withState('preShopId', 'setPreShopId', 0),
  withState('preShopName', 'setPreShopName', ''),
  withState('countryCode', 'setCountryCode', ''),
  withState('zipCode', 'setZipCode', ''),
  withState('prefectureCode', 'setPrefectureCode', 0),
  withState('prefectures', 'setPrefectures', ''),
  withState('city', 'setCity', ''),
  withState('cityName', 'setCityName', ''),
  withState('cityId', 'setCityId', ''),
  withState('address', 'setAddress', ''),
  withState('building', 'setBuilding', ''),
  withState('phone', 'setPhone', ''),
  withState('email', 'setEmail', ''),
  withState('businessHours', 'setBusinessHours', ''),
  withState('holiday', 'setHoliday', ''),
  withState('access', 'setAccess', ''),
  withState('webPage', 'setWebPage', ''),
  withState('comment', 'setComment', ''),
  withState('message', 'setMessage', ''),
  withState('preGochis', 'setPreGochis', null),
  withState('tags', 'setTags', null),
  withState('tagStr', 'setTagStr', ''),
  withState('images', 'setImages', null),
  withState('status', 'setStatus', ''),
  withState('statusStr', 'setStatusStr', ''),
  withState('createdAt', 'setCreatedAt', ''),
  withState('updatedAt', 'setUpdatedAt', ''),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('targetRowId', 'setTargetRowId', 0),
  withState('order', 'setOrder', ''),
  withState('orderBy', 'setOrderBy', ''),
  withState('page', 'setPage', 0),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangeRowsPerPage: props => (event, rowsPerPage) => {
      props.setRowsPerPage(rowsPerPage);
    },
    handleRequestSort: props => property => {
      const isDesc = props.orderBy === property && props.order === 'desc';
      props.setOrder(isDesc ? 'asc' : 'desc');
      props.setOrderBy(property);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    progress,
    searchKey,
    page,
    selectedPage,
    totalCount,
    offset,
    handleChangePage,
    preShops,
    openDetailModal,
    updateOpenDetailModal,
    openEditModal,
    updateOpenEditModal,
    openEditConfirm,
    updateOpenEditConfirm,
    preShopId,
    setPreShopId,
    preShopName,
    setPreShopName,
    countryCode,
    setCountryCode,
    zipCode,
    setZipCode,
    prefectureCode,
    setPrefectureCode,
    prefectures,
    setPrefectures,
    city,
    setCity,
    // cityName,
    // setCityName,
    cityId,
    setCityId,
    address,
    setAddress,
    building,
    setBuilding,
    phone,
    setPhone,
    email,
    setEmail,
    businessHours,
    setBusinessHours,
    holiday,
    setHoliday,
    access,
    setAccess,
    webPage,
    setWebPage,
    comment,
    setComment,
    message,
    setMessage,
    preGochis,
    setPreGochis,
    tags,
    setTags,
    tagStr,
    setTagStr,
    images,
    setImages,
    status,
    setStatus,
    statusStr,
    setStatusStr,
    createdAt,
    setCreatedAt,
    updatedAt,
    setUpdatedAt,
    rowsPerPage,
    order,
    orderBy,
    handleChangeRowsPerPage,
    handleRequestSort
  }) => {
    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, totalCount - page * rowsPerPage);
    const detail = {
      preShopId,
      preShopName,
      countryCode,
      zipCode,
      prefectureCode,
      prefectures,
      city,
      // cityName,
      cityId,
      address,
      building,
      phone,
      email,
      businessHours,
      holiday,
      access,
      webPage,
      comment,
      message,
      preGochis,
      tags,
      tagStr,
      images,
      status,
      statusStr,
      createdAt,
      updatedAt
    };

    const getPreShop = async (id, searchflag) => {
      await actions.getPreShopDetail(id, searchflag).then(detailData => {
        checkSession(detailData);
        setPreShopId(detailData.payload.preShopId);
        setPreShopName(detailData.payload.preShopName);
        setCountryCode(detailData.payload.countryCode);
        setZipCode(detailData.payload.zipCode);
        setPrefectureCode(detailData.payload.prefectureCode);
        setPrefectures(detailData.payload.prefectures);
        setCity(detailData.payload.city);
        setCityId(detailData.payload.cityId);
        // setCityName(detailData.payload.cityName);
        setAddress(detailData.payload.address);
        setBuilding(detailData.payload.building);
        setPhone(detailData.payload.phone);
        setEmail(detailData.payload.email);
        setBusinessHours(detailData.payload.businessHours);
        setHoliday(detailData.payload.holiday);
        setAccess(detailData.payload.access);
        setWebPage(detailData.payload.webPage);
        setComment(detailData.payload.comment);
        setStatus(detailData.payload.status);
        setStatusStr(detailData.payload.statusStr);
        setMessage(detailData.payload.message);
        setTags(detailData.payload.tags);
        if (detailData.payload.tags !== null) {
          setTagStr(
            detailData.payload.tags
              .map(tag => {
                return `${tag.tagName}`;
              })
              .join(' ')
          );
        }
        setPreGochis(detailData.payload.preGochis);
        setImages(detailData.payload.images);
        setCreatedAt(detailData.payload.createdAt);
        setUpdatedAt(detailData.payload.updatedAt);
      });
    };
    const searchflag = {
      unregistered: false
    };
    const detailOpenAction = params => {
      progress.updateLoading(true);
      progress.updateOpenProgress(true);
      getPreShop(params.id, searchflag)
        .then(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          updateOpenDetailModal(true);
        })
        .catch(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
        });
    };
    const editOpenAction = id => {
      progress.updateLoading(true);
      progress.updateOpenProgress(true);
      getPreShop(id, searchflag)
        .then(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          updateOpenEditModal(true);
        })
        .catch(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
        });
    };
    return (
      <div>
        <div className={classes.scrollTable} id="scrollTableId">
          <Table stickyHeader>
            <PreShopTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
            />
            <PreShopTableBody
              preShops={preShops}
              emptyRows={emptyRows}
              page={page}
              rowsPerPage={rowsPerPage}
              detailOpenAction={detailOpenAction}
              editOpenAction={editOpenAction}
              order={order}
              orderBy={orderBy}
            />
          </Table>
        </div>
        <div>
          <ExPagination
            searchResults={preShops}
            rowsPerPage={rowsPerPage}
            page={page}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            totalCount={totalCount}
            offset={offset}
            selectedPage={selectedPage}
          />
        </div>
        <Modal
          open={openDetailModal}
          onClose={() => {
            updateOpenDetailModal(false);
          }}
        >
          <PreShopDetail
            updateOpenDetailModal={updateOpenDetailModal}
            detail={detail}
          />
        </Modal>
        <Modal open={openEditModal}>
          <PreShopEdit
            updateOpenEditModal={updateOpenEditModal}
            openEditConfirm={openEditConfirm}
            updateOpenEditConfirm={updateOpenEditConfirm}
            editInput={detail}
            searchKey={searchKey}
          />
        </Modal>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
